import { create } from 'zustand';

const useAvailabilityStore = create((set, get) => ({
  openModal: false,
  setOpenModal: (openModal) => set(() => ({ openModal })),
  message: '',
  setMessage: (message) => set(() => ({ message })),
}));

export default useAvailabilityStore;
